import classes from './CargoSizeItem.module.sass'
import close from '../../../../../assets/images/icons/close.svg'
import add from '../../../../../assets/images/icons/add.svg'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { CargoUnit } from '../../../../types/interfaces'
import { finPallet, maxCargoUnits, euroPallet, usaPallet } from '../../../../utils/constants'

type Props = {
  addUnit?: () => void
  el: CargoUnit
  units: CargoUnit[]
  index: number
  deleteUnit: (index: number) => void
  inputHandler: (index: number, value: string, fieldName: string) => void
  unitNotValid: (unit: CargoUnit) => boolean
  setUnitPattern: (el: CargoUnit, index: number, pattern: CargoUnit) => void
}

export const CargoSizeItem = ({
  addUnit,
  el,
  index,
  units,
  deleteUnit,
  inputHandler,
  unitNotValid,
  setUnitPattern,
}: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={unitNotValid(el) ? classes.ContainerBorderNotValid : classes.ContainerBorder}>
      <div className={classes.ItemLabel}>{`Место ${index + 1}`}</div>
      <div className={classes.Container}>
        <div className={classes.Inputs}>
          <div className={classes.InputContainer}>
            <label className={classes.Label}>Длина,см</label>
            <input
              type="text"
              className={darkTheme ? classes.InputDark : classes.Input}
              onChange={(e) => inputHandler(index, e.target.value, 'length')}
              value={el.length}
            />
          </div>
          <div className={classes.InputContainer}>
            <label className={classes.Label}>Ширина, см</label>
            <input
              type="text"
              className={darkTheme ? classes.InputDark : classes.Input}
              onChange={(e) => inputHandler(index, e.target.value, 'width')}
              value={units[index].width}
            />
          </div>
          <div className={classes.InputContainer}>
            <label className={classes.Label}>Высота, см</label>
            <input
              type="text"
              className={darkTheme ? classes.InputDark : classes.Input}
              onChange={(e) => inputHandler(index, e.target.value, 'height')}
              value={units[index].height}
            />
          </div>
          <div className={classes.InputContainer}>
            <label className={classes.Label}>Вес, кг</label>
            <input
              type="text"
              className={darkTheme ? classes.InputDark : classes.Input}
              onChange={(e) => inputHandler(index, e.target.value, 'weight')}
              value={units[index].weight}
            />
          </div>
          <div className={classes.InputContainer}>
            <label className={classes.Label}>Таких мест, шт</label>
            <input
              type="text"
              className={darkTheme ? classes.InputDark : classes.Input}
              onChange={(e) => inputHandler(index, e.target.value, 'count')}
              value={units[index].count}
            />
          </div>
        </div>

        <div className={classes.Patterns}>
          <div
            className={classes.PatternButton}
            onClick={() => setUnitPattern(el, index, euroPallet)}
          >
            EURO паллет
          </div>
          <div
            className={classes.PatternButton}
            onClick={() => setUnitPattern(el, index, usaPallet)}
          >
            USA паллет
          </div>
          <div
            className={classes.PatternButton}
            onClick={() => setUnitPattern(el, index, finPallet)}
          >
            FIN паллет
          </div>
        </div>

        <div className={classes.Buttons}>
          {units.length > 1 && (
            <div className={darkTheme ? classes.IconContainerDark : classes.IconContainer}>
              <img
                className={classes.Icon}
                src={close}
                alt="Удалить"
                onClick={() => deleteUnit(index)}
              />
            </div>
          )}
          {addUnit && units.length < maxCargoUnits && (
            <div
              className={darkTheme ? classes.IconContainerDark : classes.IconContainer}
              onClick={addUnit}
            >
              <img className={classes.Icon} src={add} alt="Добавить" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
